import moment, { Moment } from "moment";


export const UTCToLocalString = (utc: string, format: string) => {
    return moment.utc(utc).local().format(format);
};

export const getUtcZeroTime = (date: Moment, format: string): string  => {
    return date.clone().utc().format(format);
};

export const compareDate = (date1: string, date2: string) => {
    return moment(date1).diff(moment(date2));
};
